function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import { DEV_LIGHTER_TINT_01, DEV_LIGHTER_TINT_01_COLOR_NAME } from "styles/color-consts";
import UseCasesTabsDesktopComponent from "./use-cases-tabs-desktop-component/use-cases-tabs-desktop-component.js";
import UseCasesTabsMobileComponent from "./use-cases-tabs-mobile-component/use-cases-tabs-mobile-component.js";
import DefaultProps from "./default-props";
const COLOR_TO_CLASS_NAME = {
    [DEV_LIGHTER_TINT_01]: DEV_LIGHTER_TINT_01_COLOR_NAME
};
const UseCasesTabsComponent = (_param)=>{
    var { buttonsColor } = _param, rest = _object_without_properties(_param, [
        "buttonsColor"
    ]);
    const UseCasesTabsResponsiveComponent = useMemo(()=>withResponsiveHOC(UseCasesTabsDesktopComponent, UseCasesTabsMobileComponent), []);
    return /*#__PURE__*/ _jsx(UseCasesTabsResponsiveComponent, _object_spread_props(_object_spread({}, rest), {
        buttonsColor: COLOR_TO_CLASS_NAME[buttonsColor] || buttonsColor
    }));
};
export default UseCasesTabsComponent;
UseCasesTabsComponent.defaultProps = DefaultProps;
